import { HTTP } from '@/CallAPI'
export default {
  getListOrganization (page, perPage, status = '') {
    return HTTP.get('organizations', {
      params: {
        page: page,
        per_page: perPage,
        status: status
      }
    })
  },

  createOrganization (organization) {
    return HTTP.post('organizations', organization)
  },

  updateOrganization (organization) {
    return HTTP.put('organizations/' + organization.id, organization)
  },

  destroyOrganization (organization) {
    return HTTP.delete('organizations/' + organization.id)
  },

  showOrganization (organization) {
    return HTTP.get('organizations/' + organization.id)
  },

  getTrashOrganization (page = 1, per_page = 20) {
    return HTTP.get('/organizations/trashs', {
      params: { page, per_page }
    })
  },

  restore (data) {
    return HTTP.post('/organizations/trashs', {data}
    )
  },

  rejectOrganization (organization) {
    return HTTP.post('organizations/' + organization.id + '/rejection')
  },

  approvalOrganization (organization) {
    return HTTP.post('organizations/' + organization.id + '/approval')
  },

  getLogOrganization (organization) {
    return HTTP.get('organizations/' + organization.id + '/logs')
  }

}



// WEBPACK FOOTER //
// ./src/service/organization.js